/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { ticketMessageSchema } from './ticket-message-schema';

export const ticketSchema = z.object({
  id: z.number(),
  userId: z.string(),
  userName: z.string(),
  userEmail: z.string(),
  category: z.string(),
  status: z.string(),
  title: z.string().nullable(),
  messages: z.preprocess(
    (val) => (typeof val === 'string' ? JSON.parse(val) : val),
    z.array(ticketMessageSchema),
  ),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ITicket = z.infer<typeof ticketSchema>;
